module.exports = __webpack_public_path__ + "img/Galactapedia_Roberts_Space_Industries_RSI.835e506b.png";